import ActivityTab from './ActivityTab';
import CommentItem from '../items/CommentItem';

const CommentTab = ({ api, userId }) => (
  <ActivityTab
    api={api}
    userId={userId}
    ItemComponent={CommentItem}
    itemKey="comment.id"
    readOnly
  />
);

export default CommentTab;
